import { ROUTES } from './routes';
import { TEXT } from 'locales/translations';

export const healthInsuranceCooperationCompanies = [
  {
    route: ROUTES.dak,
    headline: TEXT.healthCheckout.selected.other.dak,
    info: TEXT.healthCheckout.selected.dak.info,
    checkoutBox: {
      aboTitle: TEXT.healthCheckoutDakBox.aboTitle,
      infoText: TEXT.healthCheckoutDakBox.infoText,
      interval: TEXT.healthCheckoutDakBox.interval,
      asteriskText: TEXT.healthCheckoutDakBox.asteriskText
    }
  },
  {
    route: ROUTES.viactiv,
    headline: TEXT.healthCheckout.selected.other.viactiv,
    info: TEXT.healthCheckout.selected.viactiv.info,
    checkoutBox: {
      aboTitle: TEXT.healthCheckoutViactivBox.aboTitle,
      infoText: TEXT.healthCheckoutViactivBox.infoText,
      interval: TEXT.healthCheckoutViactivBox.interval,
      asteriskText: TEXT.healthCheckoutViactivBox.asteriskText
    }
  },
  {
    route: ROUTES.mkk,
    headline: TEXT.healthCheckout.selected.other.mkk,
    info: TEXT.healthCheckout.selected.mkk.info,
    checkoutBox: {
      aboTitle: TEXT.healthCheckoutMkkBox.aboTitle,
      infoText: TEXT.healthCheckoutMkkBox.infoText,
      interval: TEXT.healthCheckoutMkkBox.interval,
      asteriskText: TEXT.healthCheckoutMkkBox.asteriskText
    }
  },
  {
    route: ROUTES.bigDirect,
    headline: TEXT.healthCheckout.selected.bigDirect.headline,
    info: TEXT.healthCheckout.selected.bigDirect.info,
    checkoutBox: {
      aboTitle: TEXT.healthCheckout.selected.bigDirect.aboTitle,
      infoText: TEXT.healthCheckoutDakBox.infoText,
      interval: TEXT.healthCheckoutDakBox.interval,
      asteriskText: TEXT.healthCheckoutDakBox.asteriskText
    }
  },
  {
    route: ROUTES.ikkClassic,
    headline: TEXT.healthCheckout.selected.ikkClassic.headline,
    info: TEXT.healthCheckout.selected.ikkClassic.info,
    checkoutBox: {
      aboTitle: TEXT.healthCheckout.selected.ikkClassic.aboTitle,
      infoText: TEXT.healthCheckoutIkkClassicBox.infoText,
      interval: TEXT.healthCheckoutIkkClassicBox.interval,
      asteriskText: TEXT.healthCheckoutIkkClassicBox.asteriskText
    }
  },
  {
    route: ROUTES.hkk,
    headline: TEXT.healthCheckout.selected.hkk.headline,
    info: TEXT.healthCheckout.selected.hkk.info,
    checkoutBox: {
      aboTitle: TEXT.healthCheckout.selected.hkk.aboTitle,
      infoText: TEXT.healthCheckoutHkkBox.infoText,
      interval: TEXT.healthCheckoutHkkBox.interval,
      asteriskText: TEXT.healthCheckoutHkkBox.asteriskText
    }
  },
  {
    route: ROUTES.vividaBkk,
    headline: TEXT.healthCheckout.selected.vividaBkk.headline,
    info: TEXT.healthCheckout.selected.vividaBkk.info,
    checkoutBox: {
      aboTitle: TEXT.healthCheckout.selected.vividaBkk.aboTitle,
      infoText: TEXT.healthCheckoutVividaBkkBox.infoText,
      interval: TEXT.healthCheckoutVividaBkkBox.interval,
      asteriskText: TEXT.healthCheckoutVividaBkkBox.asteriskText
    }
  },
  {
    route: ROUTES.salusBkk,
    headline: TEXT.healthCheckout.selected.salusBkk.headline,
    info: TEXT.healthCheckout.selected.salusBkk.info,
    checkoutBox: {
      aboTitle: TEXT.healthCheckout.selected.salusBkk.aboTitle,
      infoText: TEXT.healthCheckoutSalusBkkBox.infoText,
      interval: TEXT.healthCheckoutSalusBkkBox.interval,
      asteriskText: TEXT.healthCheckoutSalusBkkBox.asteriskText
    }
  }
];
